import React, { MouseEventHandler, PropsWithChildren } from 'react';

import type { ReactElement } from 'react';

type types = 'underlined' | 'primary' | 'secondary' | 'arrow' | 'text';
type themes = 'dark' | 'light';

export type CtaProps = {
	link?: string;
	role?: string;
	label?: string;
	tabindex?: number;
	icon?: string;
	theme?: themes;
	type?: types;
	className?: string;
	btnType?: 'button' | 'submit';
	newWindow?: boolean;
	onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
	disabled?: boolean;
	dataCy?: string;
	useTokens?: boolean;
} & React.HTMLAttributes<HTMLAnchorElement | HTMLButtonElement>;

const Cta = React.forwardRef(
	(
		{
			link,
			role,
			label,
			tabindex,
			icon,
			theme = 'light',
			type = 'underlined',
			className = '',
			btnType = 'button',
			newWindow = false,
			children,
			onClick,
			disabled = false,
			dataCy,
			useTokens = false,
			...rest
		}: PropsWithChildren<CtaProps>,
		ref: any
	): ReactElement => {
		let ctaClass = `${className}  CTA CTA`;

		if (icon) {
			ctaClass += `--underlined--${theme}--${icon}`;
		} else {
			ctaClass += `--${type}--${theme}`;
		}

		if (useTokens) {
			ctaClass = className;
		}

		return link && !disabled ? (
			// eslint-disable-next-line react/jsx-no-target-blank
			<a
				role={role}
				aria-label={label}
				tabIndex={tabindex}
				className={ctaClass}
				href={link}
				target={newWindow ? '_blank' : undefined}
				onClick={onClick}
				rel={newWindow ? 'noreferrer' : undefined}
				data-cy={dataCy}
				ref={ref}
				{...rest}
			>
				{children}
			</a>
		) : (
			<button
				type={btnType}
				role={role}
				aria-label={label}
				tabIndex={tabindex}
				className={ctaClass}
				onClick={onClick}
				disabled={disabled}
				data-cy={dataCy}
				ref={ref}
				{...rest}
			>
				{children}
			</button>
		);
	}
);

export default Cta;
